//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
export interface IPartner {
    id: number;
    name: string;
}

export interface IPartnerListResponse {
    partners: IPartner[];
}

 // Note: Matching Client settings are in cyberstack and in the API.
export enum Partners {
    "Cigent" = 0,
    "Doqubiz" = 1,
    "Digistor" = 2,
    "Seagate" = 3,
    "Kanguru"= 4,
    "Lenovo"= 5,
    "VRS"= 6
}

export const LenovoUserAgreementURL = "https://support.lenovo.com/us/en/solutions/ht100141";
export const LenovoPrivacyURL = "https://www.lenovo.com/privacy";

export const CigentUserAgreementURL = "https://www.cigent.com/license-agreements";
export const CigentPoliciesURL = "https://www.cigent.com/policies";
export const CigentTermsURL = "https://www.cigent.com/terms";
